<template>
  <div class="home">
    <div id="MyViewerDiv" class="model" v-show="modelShow"></div>
    <el-select v-model="model2dpath" @change="change2d" v-if="model2dpath"
      style="position: absolute;top:94vh; left:2%;">
      <el-option v-for="item in model2d" :key="item.tdmd03" :label="item.tdmd03" :value="item.tdmd04">
      </el-option>
    </el-select>
    <div id="editor" v-show="officeShow"></div>
    <iframe v-show="iframeShow" :src="iframeUrl" style="width: 100%; height: 100%;"></iframe>
    <img :src="iframeUrl" v-show="imgShow" style="" />
    <video id="myVideo" controls v-show="videoShow">
      <source :src="iframeUrl" type="video/mp4">
      <p>您的浏览器不支持HTML5视频，请使用现代浏览器如Chrome、Firefox或Edge。</p>
    </video>
  </div>
</template>

<script>
import {
  GetOneUploadFile
} from "@/setAxios";
export default {
  name: "viewMyDocument",
  data() {
    return {
      model2dpath: null,
      url: "",
      viewer: null,
      //模型显示
      modelShow: false,
      //onlyoffice
      officeShow: false,
      //图片显示
      imgShow: false,
      //视频显示
      videoShow: false,
      //iframe显示
      iframeShow: false,
      exts: [
        "png",
        "jpg",
        "jpeg",
        "mp4",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "ppt",
        "pptx",
        "txt",
        "gif",
        "pdf",
      ],
      iframeUrl: "",
      //当前文件详情
      OneUploadFileData: {},
      locationParams: {},
    };
  },
  methods: {
    //2d图纸切换
    change2d() {
      document.getElementById("MyViewerDiv").innerHTML = ""
      this.viewer.tearDown();
      this.viewer = null;
      this.url = this.$store.state.baseUrl + this.model2dpath
      this.viewers(this.url)
    },
    viewers(url) {
      console.log(url)
      var Params = this.locationParams,
        _this = this;
      //初始化
      var config = {
        extensions: [
          "Autodesk.Viewing.ZoomWindow",
        ],
        disabledExtensions: {
          measure: false,
          section: false,
        },
        memory: {
          limit: 32 * 1024, //32 GB
        },
        theme: "light-theme",
      };
      var myViewerDiv = document.getElementById("MyViewerDiv");
      _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
        myViewerDiv,
        config
      );
      var options = {
        document: url,
        "language": localStorage.lang == 'zh' ? "zh-HANS" : 'en',
        env: "Local",
        offline: "true",
        useADP: false,
      };
      Autodesk.Viewing.Initializer(options, function onInitialized() {
        _this.viewer.start();
        _this.viewer.loadModel(options.document, {
          isAEC: true,
        });
        _this.viewer.addEventListener(
          Autodesk.Viewing.TEXTURES_LOADED_EVENT,
          function (event) {
            // _this.viewerFunctions()
            _this.viewer.setSwapBlackAndWhite(true);
            _this.viewer.setBackgroundColor(17, 24, 32, 17, 24, 32);
          }
        );
      });
    },
  },
  created() {
    var search = window.location.hash
      .substr(1)
      .split("=")[1]
      .replace(/%3D/g, "=");
    search = Base64.decode(search).split("&");
    search.forEach((str) => {
      let name = str.slice(0, str.indexOf("="));
      let val = str.slice(str.indexOf("=") + 1);
      this.locationParams[name] = val;
    });
  },
  async mounted() {
    //判断文件类型
    var ext = this.locationParams.path
      .substring(this.locationParams.path.lastIndexOf(".") + 1)
      .toLowerCase();
    if (this.exts.indexOf(ext) > -1) {
      if (ext == "pdf") {
        this.iframeShow = true
        this.iframeUrl = this.$store.state.baseUrl + this.locationParams.path; // 文档URL
      } else if (
        ext == "pdf" ||
        ext == "txt" ||
        ext == "doc" ||
        ext == "docx" ||
        ext == "xls" ||
        ext == "CSV" ||
        ext == "xlsx" ||
        ext == "ppt" ||
        ext == "pptx") {
        this.officeShow = true
        let documentType = "";
        if (ext == "pdf" || ext == "txt" || ext == "doc" || ext == "docx") {
          documentType = "word";
        } else if (ext == "xls" || ext == "xlsx" || ext == "CSV") {
          documentType = "cell";
        } else if (ext == "ppt" || ext == "pptx") {
          documentType = "slide";
        }
        let config = {
          document: {
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudCI6eyJkaXJlY3RVcmwiOiIiLCJmaWxlVHlwZSI6InBkZiIsImluZm8iOnsib3duZXIiOiJNZSIsInVwbG9hZGVkIjoiVHVlIEF1ZyAxOSAyMDI1IiwiZmF2b3JpdGUiOm51bGx9LCJrZXkiOiIxMTYuMjMxLjEyOS41MkFVVE9JRF9VVG91Y2hfQ19fX19fX1YxLjcucGRmMTc1NTYwMjEzMTIxNSIsInBlcm1pc3Npb25zIjp7ImNoYXQiOnRydWUsImNvbW1lbnQiOmZhbHNlLCJjb3B5Ijp0cnVlLCJkb3dubG9hZCI6dHJ1ZSwiZWRpdCI6dHJ1ZSwiZmlsbEZvcm1zIjpmYWxzZSwibW9kaWZ5Q29udGVudENvbnRyb2wiOnRydWUsIm1vZGlmeUZpbHRlciI6dHJ1ZSwicHJpbnQiOnRydWUsInJldmlldyI6ZmFsc2UsInJldmlld0dyb3VwcyI6bnVsbCwiY29tbWVudEdyb3VwcyI6e30sInVzZXJJbmZvR3JvdXBzIjpudWxsLCJwcm90ZWN0Ijp0cnVlfSwicmVmZXJlbmNlRGF0YSI6eyJmaWxlS2V5Ijoie1wiZmlsZU5hbWVcIjpcIkFVVE9JRCBVVG91Y2goQynkvb_nlKjor7TmmI7kuaZWMS43LnBkZlwiLFwidXNlckFkZHJlc3NcIjpcIjExNi4yMzEuMTI5LjUyXCJ9IiwiaW5zdGFuY2VJZCI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZSJ9LCJ0aXRsZSI6IkFVVE9JRCBVVG91Y2goQynkvb_nlKjor7TmmI7kuaZWMS43LnBkZiIsInVybCI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZS9kb3dubG9hZD9maWxlTmFtZT1BVVRPSUQlMjBVVG91Y2goQyklRTQlQkQlQkYlRTclOTQlQTglRTglQUYlQjQlRTYlOTglOEUlRTQlQjklQTZWMS43LnBkZiZ1c2VyYWRkcmVzcz0xMTYuMjMxLjEyOS41MiJ9LCJkb2N1bWVudFR5cGUiOiJwZGYiLCJlZGl0b3JDb25maWciOnsiYWN0aW9uTGluayI6bnVsbCwiY2FsbGJhY2tVcmwiOiJodHRwOi8vOC4xNTMuMTc1LjIwMDo4MDExL2V4YW1wbGUvdHJhY2s_ZmlsZW5hbWU9QVVUT0lEJTIwVVRvdWNoKEMpJUU0JUJEJUJGJUU3JTk0JUE4JUU4JUFGJUI0JUU2JTk4JThFJUU0JUI5JUE2VjEuNy5wZGYmdXNlcmFkZHJlc3M9MTE2LjIzMS4xMjkuNTIiLCJjb0VkaXRpbmciOm51bGwsImNyZWF0ZVVybCI6bnVsbCwiY3VzdG9taXphdGlvbiI6eyJhYm91dCI6dHJ1ZSwiY29tbWVudHMiOnRydWUsImNsb3NlIjp7InZpc2libGUiOmZhbHNlfSwiZmVlZGJhY2siOnRydWUsImZvcmNlc2F2ZSI6ZmFsc2UsImdvYmFjayI6eyJibGFuayI6ZmFsc2UsInVybCI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZSJ9LCJzdWJtaXRGb3JtIjpmYWxzZX0sImVtYmVkZGVkIjp7ImVtYmVkVXJsIjoiaHR0cDovLzguMTUzLjE3NS4yMDA6ODAxMS9leGFtcGxlL2Rvd25sb2FkP2ZpbGVOYW1lPUFVVE9JRCUyMFVUb3VjaChDKSVFNCVCRCVCRiVFNyU5NCVBOCVFOCVBRiVCNCVFNiU5OCU4RSVFNCVCOSVBNlYxLjcucGRmIiwic2F2ZVVybCI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZS9kb3dubG9hZD9maWxlTmFtZT1BVVRPSUQlMjBVVG91Y2goQyklRTQlQkQlQkYlRTclOTQlQTglRTglQUYlQjQlRTYlOTglOEUlRTQlQjklQTZWMS43LnBkZiIsInNoYXJlVXJsIjoiaHR0cDovLzguMTUzLjE3NS4yMDA6ODAxMS9leGFtcGxlL2Rvd25sb2FkP2ZpbGVOYW1lPUFVVE9JRCUyMFVUb3VjaChDKSVFNCVCRCVCRiVFNyU5NCVBOCVFOCVBRiVCNCVFNiU5OCU4RSVFNCVCOSVBNlYxLjcucGRmIiwidG9vbGJhckRvY2tlZCI6InRvcCJ9LCJmaWxlQ2hvaWNlVXJsIjoiIiwibGFuZyI6ImVuIiwibW9kZSI6InZpZXciLCJwbHVnaW5zIjp7InBsdWdpbnNEYXRhIjpbXX0sInRlbXBsYXRlcyI6bnVsbCwidXNlciI6eyJncm91cCI6IiIsImlkIjoidWlkLTEiLCJpbWFnZSI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZS9pbWFnZXMvdWlkLTEucG5nIiwibmFtZSI6IkpvaG4gU21pdGgiLCJyb2xlcyI6bnVsbH19LCJoZWlnaHQiOiIxMDAlIiwidG9rZW4iOiIiLCJ0eXBlIjoiZGVza3RvcCIsIndpZHRoIjoiMTAwJSIsImlhdCI6MTc1NTYwMjI5NCwiZXhwIjoxNzU1NjAyNTk0fQ.JrvZ3Aa8fIxZ-f9e7WcecI_MF65XyBUvcp0SwJSal8A',
            fileType: ext,
            title: this.locationParams.name,
            url: this.$store.state.baseUrl + this.locationParams.path, // 文档URL
            permissions: { // 关闭所有权限
              edit: false,
              download: false,
              print: false,
              review: false,
              fillForms: false,
              comment: false
            }
          },
          documentType: documentType,
          editorConfig: {
            lang: "zh", // 设置为中文
            mode: "view", // 强制设为查看模式
            user: {
              id: "viewer-1",
              name: "查看者"
            },
            customization: {
              hideLogo: true        // 直接隐藏logo
            }
          },
          height: "100%",
          width: "100%"
        };
        function generateOnlyOfficeToken(payload, secret) {
          // Header 部分
          const header = {
            alg: 'HS256', // 算法：OnlyOffice 使用 HS256
            typ: 'JWT'
          };

          // 将 Header 和 Payload 转换为 Base64Url 字符串
          const sHeader = JSON.stringify(header);
          const sPayload = JSON.stringify(payload);

          // 使用 jsrsasign 库生成 Token
          const sJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, secret);

          return sJWT;
        }

        // 使用方法
        const yourSecret = '8v6evC2ITvNw0nlAtS7TUJzeiDtSNV'; // 你的 OnlyOffice 密钥

        const jwtToken = generateOnlyOfficeToken(config, yourSecret);

        config.document.token = jwtToken;


        new DocsAPI.DocEditor("editor", config);
      }
      else if (ext == "mp4") {
        this.videoShow = true
        this.iframeUrl = this.$store.state.baseUrl + this.locationParams.path;
      }
      else if (ext == "jpg" || ext == "png" || ext == "gif" || ext == "jpeg") {
        this.imgShow = true
        this.iframeUrl = this.$store.state.baseUrl + this.locationParams.path;
      }
    } else {//模型文件
      let params = { guid: this.locationParams.fileId };
      let res = await GetOneUploadFile({ params })
      this.OneUploadFileData = res.Data
      if (res.Data) {
        //状态（0 转换中 1转换失败 2转换成功）
        if (res.Data.modelstate && res.Data.modelstate.mdst05 == 2) {
          this.modelShow = true;
          if (res.Data.file.ext.includes('dwg') || res.Data.model.mode09.includes('f2d')) {//dwg单独处理
            this.model2d = res.Data.model2d
            this.model2dpath = res.Data.model2d[0].tdmd04
            this.url = this.$store.state.baseUrl + this.model2dpath
            this.viewers(this.url)
          } else
            this.viewers(this.$store.state.baseUrl + res.Data.model.mode09);
        } else {
          this.$message({
            type: "error",
            message: !res.Data.modelstate ? this.$t('common.请先进行模型转换')
              : res.Data.modelstate.mdst05 == 0 ? this.$t('common.转换中')
                : res.Data.modelstate.mdst05 == 1 ? this.$t('common.转换失败') : this.$t('common.转换成功'),
          })
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  position: relative;

  .model {
    position: fixed;
    width: 100%;
    height: 100%;
  }

  #editor {
    width: 100%;
    height: 100vh;
  }

  #myVideo {
    position: absolute;
    left: 30%;
    top: 0;
  }
}
</style>
